import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import { NavigationSetter } from "@/components/NavigationSetter";
import { Toaster } from "@/components/ui/sonner";
import { useFuelExhaustionNotification } from "@/hooks/useFuelExhaustionNotification";
import { queryClient } from "@/lib/query";
import { AppRoutes } from "@/routes/AppRoutes";

const FuelExhaustionNotificationListener = () => {
  useFuelExhaustionNotification();
  return null;
};

export const App = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <NavigationSetter />
      <FuelExhaustionNotificationListener />
      <Toaster />
      <AppRoutes />
    </BrowserRouter>
  </QueryClientProvider>
);
